import React from "react";
import { Row, Col } from "antd";
import styles from "../DashBoard/DashBoard.module.scss";

const FavoritesTabInfo = () => {
  return (
    <Row className={styles.favoritesTabInfo} gutter={[0, 15]}>
      <Col span={24}>
        Services that you use often can be saved as Favorites, so you don't have
        to re-enter the service details every time you book them.
      </Col>
      <Col span={24}>
        After hitting the "Rebook" button, you'll be able to review and edit all
        service details.
      </Col>
    </Row>
  );
};
export default FavoritesTabInfo;
